import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  containerClassName?: string;
}
export function Section({
  className,
  containerClassName,
  children,
  ...props
}: SectionProps) {
  return <section className={cn('py-10 md:py-14 px-4 md:px-6 w-full overflow-hidden', className)} {...props} data-id="element-336">
      <div className={cn('max-w-6xl mx-auto', containerClassName)} data-id="element-337">
        {children}
      </div>
    </section>;
}